export const surfaceSx = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2.4,
  bgcolor: "background.paper",
  boxShadow: "0 7px 22px rgba(var(--wp-panel-ink-rgb,25,36,47),.045)",
};

export function idOf(value) {
  return String(value?.id || value?._id || value || "");
}

export function money(value, currency = "ARS") {
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: currency || "ARS",
      maximumFractionDigits: currency === "ARS" ? 0 : 2,
    }).format(Number(value || 0));
  } catch {
    return `${currency || "ARS"} ${Number(value || 0).toLocaleString("es-AR")}`;
  }
}

export function shortDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("es-AR", { day: "2-digit", month: "short", year: "numeric" }).format(date);
}

export function dateTimeLocalValue(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const shifted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return shifted.toISOString().slice(0, 16);
}
